import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class PrintAndSendButtonModel extends ButtonBase {
    label: string = 'Print and Send';
    action: string = ACTION_STATUS.print;
    matIconName: string = 'description';
    colorClass: string = 'color-info-500';
}